import { UDText } from 'ud-ui/components';
import { theme } from 'styles/theme/theme';

export const Format = () => {
  return (
    <UDText type="caption-1" color={theme.colors.SurfaceRomanSilver30}>
      Формат: png, jpg
    </UDText>
  );
};
